import React from 'react';

interface Props {
  className?: string;
}

const Pipeline: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="25"
    viewBox="0 0 24 25"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      fill="currentColor"
      height="6"
      transform="translate(0 11)"
      width="24"
    />
    <circle cx="2" cy="14" fill="white" r="1" />
    <circle cx="6" cy="14" fill="white" r="1" />
    <circle cx="10" cy="14" fill="white" r="1" />
    <circle cx="14" cy="14" fill="white" r="1" />
    <circle cx="18" cy="14" fill="white" r="1" />
    <circle cx="22" cy="14" fill="white" r="1" />
  </svg>
);

export default Pipeline;
